import { LinkIcon } from 'custom_modules/Sidebar/sidebarStyles';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import linkIcon from '../../../assets/img/icons/link_2.svg';
import plusIcon from '../../../assets/img/icons/plus_white.svg';
import editIcon from '../../../assets/img/icons/edit.svg';
import unarchiveIcon from '../../../assets/img/archive.svg';
import BackButtonComponent from '../../../components/BackButtonComponent/BackButtonComponent';
import CreateProjectDropdown from '../../../components/DropdownStyle/CreateProjectDropdown';
import ButtonTextLoader from '../../../components/Loaders/ButtonTextLoader';
import Select from '../../../components/ReactSelectDropdown';
import {
  ButtonIcon,
  ColoredButton,
  ColoredButtonWithIcon,
  PrimaryButton,
  WhiteButton,
  WhiteButtonWithIcon,
  ToggleButton,
  ToggleButtonGroup,
} from '../../../styledComponents/buttons';
import {
  ColoredText,
  CommonFlex,
  CommonGrid,
  CommonText,
  Container,
  ContentHeader,
  FormAlert,
  InputField,
  InputLabel,
  InputTextArea,
  InputWithLabelSection,
  PageTitle,
  RedStar,
} from '../../../styledComponents/common';
import { colors } from '../../../styles/light/colors';
import {
  ButtonContainer,
  MasterTaskTable,
  SelectWrapper,
  TableBody,
  TableContainer,
  TableHeader,
  TableRow,
} from '../tasksStyles';
import AddNewTaskModal from './AddNewTaskModal';
import MaxTaskDurationModal from './MaxTaskDurationModal';

const MasterTask = ({
  history,
  selectedOrganization,
  taskTypeIsLoading,
  taskTypeList,
  getOrganizationMembersList,
  getTaskType,
  createMasterTask,
  updateMasterTask,
  archiveMasterTask,
  unarchiveMasterTask,
  isCreateMasterTaskLoading,
  isUpdateMasterTaskLoading,
  isArchiveMasterTaskLoading,
  isUnarchiveMasterTaskLoading,
  createdMasterTaskInfo,
  updatedMasterTaskInfo,
  archivedMasterTaskInfo,
  unarchiveMasterTaskInfo,
  clearMasterTaskState,
  getMasterTask,
  isMasterTaskLoading,
  MasterTasks,
  getNewTasks,
  isNewTaskLoading,
  NewTasks,
  clearNewTaskState,
  createLinkTask,
  isLinkMasterTaskLoading,
  createdLinkTaskInfo,
  clearLinkTaskState,
  createMaxTaskDuration,
  isMaxTaskDurationLoading,
  maxTaskDurationInfo,
  clearMaxTaskTimeState,
  getMaxTaskDuration,
  fetchedMaxTaskDuration,
}) => {
  const { t, i18n } = useTranslation();
  const [selectedTaskType, setSelectedTaskType] = useState('');
  const [statusOptions, setStatusOptions] = useState([]);
  const [saveErrors, setSaveErrors] = useState({});
  const [masterTaskList, setMasterTaskList] = useState([]);
  const [newTaskList, setNewTaskList] = useState([]);
  const [showArchived, setShowArchived] = useState(false);
  const [unarchivingTaskId, setUnarchivingTaskId] = useState(null);
  const [archivingTaskId, setArchivingTaskId] = useState(null);

  // State to store selected items
  const [selectedLeftTask, setSelectedLeftTask] = useState(null); // Single selection
  const [selectedRightTask, setSelectedRightTask] = useState(null);
  const [maxDurationModalOpen, setMaxDurationModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [taskToEdit, setTaskToEdit] = useState(null);

  const [popupOpen, setPopupOpen] = useState(false);
  const popupToggle = () => {
    setPopupOpen(!popupOpen);
  };

  const periodList = [
    { label: 'Before Hajj', value: 'before_hajj' },
    { label: 'During Hajj', value: 'during_hajj' },
    { label: 'After Hajj', value: 'after_hajj' },
    { label: 'All Time', value: 'all_time' },
  ];

  useEffect(() => {
    return () => {
      clearNewTaskState();
      clearMasterTaskState();
      setArchivingTaskId(null);
      setUnarchivingTaskId(null);
    };
  }, []);

  useEffect(() => {
    getTaskType();
    getMaxTaskDuration(); // Fetch max task duration on component mount
  }, []);

  useEffect(() => {
    if (selectedTaskType) {
      getMasterTask({
        master_task_id: selectedTaskType.value,
        show_archived: showArchived
      });
      getNewTasks({ task_type: selectedTaskType.value });
    }
  }, [selectedTaskType, showArchived]);

  useEffect(() => {
    if (NewTasks) {
      const options = NewTasks.map(task => ({
        label: task.name,
        value: task.id,
      }));

      setNewTaskList(options);
    }
  }, [NewTasks]);

  useEffect(() => {
    if (MasterTasks && selectedTaskType) {
      const options = MasterTasks
        .filter(task => showArchived ? !task.is_active : task.is_active)
        .map(task => ({
          label: task.name,
          value: task.id,
        }));

      setMasterTaskList(options);
    }
  }, [MasterTasks, selectedTaskType, showArchived]);

  useEffect(() => {
    if (taskTypeList && taskTypeList.length > 0) {
      let newArr = [];
      if (i18n.language && i18n.language === 'en') {
        taskTypeList.forEach(type => {
          newArr.push({
            label: type.name,
            value: type.id,
          });
        });
      } else {
        taskTypeList.forEach(type => {
          newArr.push({
            label: type.arabic_name,
            value: type.id,
          });
        });
      }
      setStatusOptions(newArr);
    }
  }, [taskTypeList]);

  useEffect(() => {
    if (createdLinkTaskInfo) {
      // Update: new tasks wont be added to master task table
      // 1. Add to Master Task List (left table)
      //  setMasterTaskList(prev => [
      //    ...prev,
      //    {
      //      label: createdLinkTaskInfo.name,
      //      value: createdLinkTaskInfo.id,
      //    },
      //  ]);

      // 2. Remove from New Task List (right table)
      // Don't have id so that why removing using the name
      setNewTaskList(prev =>
        prev.filter(task => task.label !== createdLinkTaskInfo.name),
      );

      // 3. Clear selections
      setSelectedLeftTask(null);
      setSelectedRightTask(null);

      // 4. ✅ Clear link task state
      setTimeout(() => {
        clearLinkTaskState();
      }, 0);
    }
  }, [createdLinkTaskInfo]);

  const handleMasterTaskCreated = newTask => {
    if (newTask?.task_type === selectedTaskType?.value) {
      setMasterTaskList(prev => [
        ...prev,
        {
          label: newTask.name,
          value: newTask.id,
        },
      ]);
    }
  };

  const onTaskTypeChange = e => {
    setSelectedTaskType(e);
  };

  // Function to handle radio button selection (left table)
  const handleLeftTaskSelect = (value) => {
    setSelectedLeftTask(prev => (prev === value ? null : value));
  };

  // Function to handle checkbox for multiple selection (right table)
  // const handleRightTaskSelect = event => {
  //   const task = event.target.value;
  //   if (event.target.checked) {
  //     setSelectedRightTasks([...selectedRightTasks, task]); // Add to selection
  //   } else {
  //     setSelectedRightTasks(selectedRightTasks.filter(t => t !== task)); // Remove from selection
  //   }
  // };

  const handleRightTaskSelect = (value) => {
    setSelectedRightTask(prev => (prev === value ? null : value));
  };

  // Function to handle button click
  const handleLinkClick = () => {
    // console.log('master_task_id', selectedLeftTask);
    // console.log('link_task_id', selectedRightTask);
    createLinkTask({
      master_task_id: selectedLeftTask,
      link_task_id: selectedRightTask,
    });
  };

  const handleRemoveNewTask = id => {
    setNewTaskList(prev =>
      prev.filter(task => String(task.value) !== String(id)),
    );
  };

  // Function to handle edit button click
  const handleEditClick = (task, e) => {
    e.stopPropagation(); // Prevent row selection

    console.log('task', MasterTasks);
    const taskData = MasterTasks.find(mt => mt.id === task.value) || {
      id: task.value,
      name: task.label,
      task_type: selectedTaskType?.value,
      default_task_duration: "1.00",
      task_period: "all_time"
    };

    setTaskToEdit({
      ...task,
      taskData
    });
    setIsEditMode(true);
    setPopupOpen(true);
  };

  // Function to handle unarchive button click
  const handleUnarchiveClick = (task, e) => {
    e.stopPropagation(); // Prevent row selection
    setUnarchivingTaskId(task.value);
    unarchiveMasterTask({
      id: task.value
    });
  };

  // Effect to handle update success
  useEffect(() => {
    if (updatedMasterTaskInfo) {
      // Refresh master task list
      if (selectedTaskType) {
        getMasterTask({ master_task_id: selectedTaskType.value });
      }

      // Close modal and reset state
      setIsEditMode(false);
      setTaskToEdit(null);
      setPopupOpen(false);

      // Clear state
      clearMasterTaskState();
    }
  }, [updatedMasterTaskInfo]);

  // Effect to handle archive success
  useEffect(() => {
    if (archivedMasterTaskInfo) {
      // Refresh master task list
      if (selectedTaskType) {
        getMasterTask({
          master_task_id: selectedTaskType.value,
          show_archived: showArchived
        });
      }

      // Clear archiving task ID
      setArchivingTaskId(null);

      // Close modal if open
      if (popupOpen) {
        setIsEditMode(false);
        setTaskToEdit(null);
        setPopupOpen(false);
      }

      // Clear state
      clearMasterTaskState();
    }
  }, [archivedMasterTaskInfo]);

  // Effect to handle unarchive success
  useEffect(() => {
    if (unarchiveMasterTaskInfo) {
      // Refresh master task list
      if (selectedTaskType) {
        getMasterTask({
          master_task_id: selectedTaskType.value,
          show_archived: showArchived
        });
      }

      // Clear unarchiving task ID
      setUnarchivingTaskId(null);

      // Clear state
      clearMasterTaskState();
    }
  }, [unarchiveMasterTaskInfo]);

  return (
    <div className="content">
      <MaxTaskDurationModal
        isOpen={maxDurationModalOpen}
        toggle={() => setMaxDurationModalOpen(false)}
        createMaxTaskDuration={createMaxTaskDuration}
        isMaxTaskDurationLoading={isMaxTaskDurationLoading}
        maxTaskDurationInfo={maxTaskDurationInfo}
        clearMaxTaskTimeState={clearMaxTaskTimeState}
        initialDuration={fetchedMaxTaskDuration?.max_task_duration ? parseFloat(fetchedMaxTaskDuration.max_task_duration) : null}
      />
      <AddNewTaskModal
        isOpen={popupOpen}
        toggle={() => {
          setPopupOpen(false);
          setIsEditMode(false);
          setTaskToEdit(null);
        }}
        statusOptions={statusOptions}
        periodList={periodList}
        createMasterTask={createMasterTask}
        updateMasterTask={updateMasterTask}
        archiveMasterTask={(params) => {
          setArchivingTaskId(params.id);
          archiveMasterTask(params);
        }}
        isCreateMasterTaskLoading={isCreateMasterTaskLoading}
        isUpdateMasterTaskLoading={isUpdateMasterTaskLoading}
        isArchiveMasterTaskLoading={isArchiveMasterTaskLoading}
        createdMasterTaskInfo={createdMasterTaskInfo}
        updatedMasterTaskInfo={updatedMasterTaskInfo}
        clearMasterTaskState={clearMasterTaskState}
        onTaskCreated={handleMasterTaskCreated}
        //auto selecting values
        prefillTaskType={selectedTaskType}
        prefillTaskName={
          isEditMode
            ? taskToEdit?.label
            : newTaskList.find(task => task.value === selectedRightTask)?.label || ''
        }
        prefillNewTaskId={selectedRightTask}
        onNewTaskUsed={handleRemoveNewTask}
        isEditMode={isEditMode}
        taskToEdit={taskToEdit}
      />
      <PageTitle>{t('master_task')}</PageTitle>
      <ContentHeader>
        <BackButtonComponent
          onClick={() => history.push('/user/tasks')}
          subTitle={t('back_to_all_tasks')}
        />
      </ContentHeader>
      <Container padding="30px">
        <CommonGrid alignItem="center">
          <InputWithLabelSection style={{ width: '400px' }}>
            <InputLabel style={{ marginBottom: '10px' }}>
              {t('task_type')}
            </InputLabel>
            <Select
              isSearchable
              value={selectedTaskType}
              options={statusOptions}
              placeholder={t('select_type')}
              onChange={e => {
                onTaskTypeChange(e);
              }}
              styles={CreateProjectDropdown()}
            />{' '}
            {saveErrors &&
              saveErrors['taskType'] &&
              saveErrors['taskType'] !== undefined && (
                <FormAlert>{saveErrors['taskType']}</FormAlert>
              )}
          </InputWithLabelSection>
          <CommonFlex margin="10px 0 0 0" gap="12px">
            {localStorage.getItem('user_role') !== 'employee' ||
            localStorage.getItem('user_role') !== 'supervisor' ? (
              <>
                <ColoredButtonWithIcon
                  onClick={() => setMaxDurationModalOpen(true)}
                  bgColor={colors.info}
                  hoverBgColor={colors.info}
                >
                  {t('max_task_duration')}
                </ColoredButtonWithIcon>
                <ColoredButtonWithIcon
                  disabled={!selectedLeftTask || !selectedRightTask}
                  style={{
                    opacity: !selectedLeftTask || !selectedRightTask ? 0.5 : 1,
                    cursor:
                      !selectedLeftTask || !selectedRightTask
                        ? 'not-allowed'
                        : 'pointer',
                  }}
                  onClick={handleLinkClick}
                  bgColor={colors.success}
                  hoverBgColor={colors.success}
                >
                  <ButtonIcon src={linkIcon} alt="" />
                  {isLinkMasterTaskLoading ? (
                    <ButtonTextLoader
                      color="#fff"
                      loadingText="Linking"
                      size={4}
                    />
                  ) : (
                    t('link')
                  )}
                </ColoredButtonWithIcon>
              </>
            ) : null}
            {localStorage.getItem('user_role') !== 'employee' &&
              !localStorage.getItem('viewer_role') && (
                <ColoredButtonWithIcon onClick={() => popupToggle()}>
                  <ButtonIcon src={plusIcon} alt="" />
                  {t('add_new_master_task')}
                </ColoredButtonWithIcon>
              )}
          </CommonFlex>
        </CommonGrid>

        <CommonFlex style={{ marginTop: '10px', justifyContent: 'space-between', alignItems: 'center' }}>
          <CommonText>{showArchived ? 'Showing Archived Tasks' : 'Showing Active Tasks'}</CommonText>
          <ToggleButtonGroup>
            <ToggleButton
              active={!showArchived}
              onClick={() => setShowArchived(false)}
            >
              {t('active')}
            </ToggleButton>
            <ToggleButton
              active={showArchived}
              onClick={() => setShowArchived(true)}
            >
              {t('archived')}
            </ToggleButton>
          </ToggleButtonGroup>
        </CommonFlex>

        <MasterTaskTable style={{ marginTop: '25px', marginBottom: '40px' }}>
          <TableContainer>
            <TableHeader>{showArchived ? t('archived_master_tasks') : t('list_of_master_tasks')}</TableHeader>
            <TableBody>
              {isMasterTaskLoading ? (
                <ButtonTextLoader color="#000" loadingText="" size={4} />
              ) : masterTaskList && masterTaskList.length > 0 ? (
                masterTaskList.map((task, index) => (
                  <TableRow
                    key={index}
                    isSelected={!showArchived && selectedLeftTask === task.value}
                    onClick={() => !showArchived && handleLeftTaskSelect(task.value)}
                    style={{ cursor: showArchived ? 'default' : 'pointer' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {!showArchived && (
                          <input
                            type="radio"
                            name="leftTaskSelection"
                            value={task.value}
                            checked={selectedLeftTask === task.value}
                            onChange={(e) => e.stopPropagation()}
                            onClick={(e) => e.stopPropagation()}
                          />
                        )}
                        <span style={{ marginLeft: !showArchived ? '8px' : '0' }}>{task.label}</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {!showArchived ? (
                          isArchiveMasterTaskLoading && archivingTaskId && archivingTaskId === task.value ? (
                            <ButtonTextLoader color="#000" loadingText="" fontSize="12px" size={4} />
                          ) : (
                            <img
                              src={editIcon}
                              alt="Edit"
                              onClick={(e) => handleEditClick(task, e)}
                              style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                            />
                          )
                        ) : (
                          <>
                            {isUnarchiveMasterTaskLoading && unarchivingTaskId === task.value ? (
                              <ButtonTextLoader color="#000" loadingText="" fontSize="12px" size={4} />
                            ) : (
                              <img
                                src={unarchiveIcon}
                                alt="Unarchive"
                                onClick={(e) => handleUnarchiveClick(task, e)}
                                style={{ cursor: 'pointer', width: '25px', height: '25px', marginRight: '4px' }}
                              />
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <CommonText style={{ padding: '20px', textAlign: 'center' }}>
                    {showArchived
                      ? 'No archived master tasks found. Tasks will appear here when they are archived.'
                      : 'No master tasks found. Create a new master task to get started.'}
                  </CommonText>
                </TableRow>
              )}
            </TableBody>
          </TableContainer>

          {!showArchived && (
            <TableContainer borderColor="#0392AA">
              <TableHeader borderBottomColor="#0392AA">
                {t('new_task_created')}
              </TableHeader>
              <TableBody>
                {isNewTaskLoading ? (
                  <ButtonTextLoader color="#000" loadingText="" size={4} />
                ) : newTaskList && newTaskList.length > 0 ? (
                  newTaskList.map((task, index) => (
                    <TableRow
                      key={`right-${index}`}
                      isSelected={selectedRightTask === String(task.value)}
                      onClick={() => handleRightTaskSelect(task.value)}
                      style={{ cursor: 'pointer' }}
                    >
                      <input
                        type="radio"
                        name="rightTaskSelection"
                        value={task.value}
                        checked={selectedRightTask === String(task.value)}
                        onChange={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                      />
                      {task.label}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <CommonText style={{ padding: '20px', textAlign: 'center' }}>
                      No new tasks available for this task type.
                    </CommonText>
                  </TableRow>
                )}
              </TableBody>
            </TableContainer>
          )}
        </MasterTaskTable>
      </Container>
    </div>
  );
};

export default MasterTask;
